import { warnEmptyInsurance } from '../shared/insuranceSetup';

// A provider change must not relabel an existing saved insurance product.
// Clearing the row first uses each document's existing remove-product workflow.
const providerId = value => value && typeof value === 'object' ? value.sub_category_id : value;

export default {
  data: () => ({ insuranceProviderPickerKey: 0, thirdInsuranceProviderPickerKey: 0, insuranceLookupSeq: [0, 0] }),
  methods: {
    warnEmptyInsurance,
    beginInsuranceLookup(index) {
      const seq = ++this.insuranceLookupSeq[index];
      const row = this.form.product[index];
      const selected = providerId(row && row.sub_category_id);
      const branch = this.form.branch_id;
      const route = this.$route;
      return () => !this._isDestroyed && this.$route === route &&
        this.insuranceLookupSeq[index] === seq && this.form.product[index] === row &&
        this.form.branch_id === branch && providerId(row && row.sub_category_id) === selected;
    },
    onInsuranceProviderChange(value) {
      return this.changeSavedInsuranceProvider(value, 1);
    },
    onHistoricalThirdInsuranceProviderChange(value) {
      return this.changeSavedInsuranceProvider(value, 0);
    },
    changeSavedInsuranceProvider(value, index) {
      const row = this.form.product[index];
      const id = providerId(value);
      const readOnly = typeof this.productsReadOnly === 'boolean' ? this.productsReadOnly : this.isUpdate;
      // Reset Vuetify's tentative selection when the controlled value is rejected.
      const resetPicker = () => {
        if (index === 1) this.insuranceProviderPickerKey += 1;
        else this.thirdInsuranceProviderPickerKey += 1;
      };
      if (!this.formHydrationReady || this.formHydrationFailed || readOnly ||
          !row || id === providerId(row.sub_category_id)) return resetPicker();
      const providers = index === 1 ? this.list_insurance.insurance_sub_category : this.list_insurance.third_insurance_sub_category;
      if (!providers.some(item =>
        item.sub_category_id === id && !item.disabled)) return resetPicker();
      if (row.product_id) {
        resetPicker();
        this.$alertServerError({
          title: 'Insurance provider',
          text: 'Remove the selected insurance product before choosing a different provider. Its saved details will remain unchanged until you remove it.',
          showConfirmButton: true,
          timer: false,
        });
        return;
      }
      row.sub_category_id = value;
      return index === 1 ? this.getInsuranceProduct(id) : this.getThirdInsuranceProduct(id);
    },
  },
};
